import { authRoles } from 'app/auth';
import i18next from 'i18next';

import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tr', 'navigation', tr);

const navigationConfig = [
  /* Menu - Dashboard */
  {
    id: 'applications',
    title: 'Applications',
    translate: 'APPLICATIONS',
    type: 'group',
    icon: 'apps',
    children: [
      {
        id: 'dashboard-component',
        title: 'Dashboard',
        translate: 'DASHBOARD',
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard'
      }
    ]
  },
  /* Management */
  {
    id: 'management',
    title: 'Management',
    translate: 'MANAGEMENT',
    type: 'group',
    icon: 'supervisor_account',
    children: [
      {
        id: 'system-user-management',
        title: 'Kullanıcı Yönetimi',
        type: 'item',
        icon: 'supervisor_account',
        url: '/user-management/user-list',
        auth: authRoles.admin
      },
      {
        id: 'pharmacy-management',
        title: 'Eczane Yönetimi',
        type: 'collapse',
        icon: 'store',
        children: [
          {
            id: 'pharmacy-list',
            title: 'Eczane Listesi',
            type: 'item',
            url: '/pharmacy-management/pharmacy-list'
          },
          {
            id: 'pharmacy-on-duty',
            title: 'Nöbet Listesi',
            type: 'item',
            url: '/pharmacy-on-duty-management/pharmacy-on-duty-list'
          },
          {
            id: 'pharmacy-support-list',
            title: 'Eczane Destek Formları',
            type: 'item',
            url: '/pharmacy-support/pharmacy-support-list'
          }
        ]
      },
      {
        id: 'customer-management',
        title: 'Müşteri Yönetimi',
        type: 'item',
        icon: 'account_box',
        url: '/customer-management'
      },
      {
        id: 'order-management',
        title: 'Sipariş Yönetimi',
        type: 'item',
        icon: 'shopping_cart',
        url: '/order-management/order-list'
      },
      {
        id: 'campaign-management',
        title: 'Kampanya Yönetimi',
        type: 'item',
        icon: 'campaign',
        url: '/campaign-management/campaign-list'
      },
      {
        id: 'parameter-management',
        title: 'Parametre Yönetimi',
        type: 'collapse',
        icon: 'app_settings_alt',
        children: [
          {
            id: 'product-management',
            title: 'Ürün Yönetimi',
            type: 'item',
            url: '/product-management/products-list'
          },
          {
            id: 'mobile-agreements-management',
            title: 'Mobil Sözleşme Yönetimi',
            type: 'item',
            url: '/parameter-management/mobile-agreements-management'
          },
          {
            id: 'address-management',
            title: 'Adres Yönetimi',
            type: 'item',
            url: '/parameter-management/address-management'
          },
          {
            id: 'app-version-management',
            title: 'Uygulama Versiyon Yönetimi',
            type: 'item',
            url: '/parameter-management/app-version-management'
          }
        ]
      },
      {
        id: 'log-management',
        title: 'Log Yönetimi',
        type: 'item',
        icon: 'library_books',
        url: '/log-management/log-list'
      }
    ]
  }
];

export default navigationConfig;
